import { combineReducers } from "redux";
import { authReducer } from "./auth/authReducer";
import { getUserListReducer } from "./user-management/getUserList";
import { getUserDetailsReducer } from "./user-management/getUserDetailsReducer";
import { getAdvListReducer } from "./advertisement/getAdvList";
import { getBrandingListReducer } from "./branding/getBrandingList";
import { getAdvDetailsDataReducer } from "./advertisement/getAdvDetailsData";
import { getPodcastListReducer } from "./podcast/getPodcastList";
import { getPodcastDetailsDataReducer } from "./podcast/getPodcastDetailsData";
import { getProfileReducer } from "./profile/getProfileReducer";
import { getCmsDataReducer } from "./profile/getCmsDataReducer";
import { getUserActivityReducer } from "./user-management/getUserActivityReducer";
import { getAllocatedCategoryReducer } from "./profile/getAllocatedCategoryReducer";
import { dashboardDataReducer } from "./dashboard/dashboardReducer";
import cmsManagementReducer from "./../reducer/cmsManagementSlice";
import notificationReducer from "./../reducer/NotificationSlice";
import TenantnReducer from "./../reducer/TenantSlice";

import { getUserActivityLogReducer } from "./user-management/getUserActivityLogReducer";

export const reducers = combineReducers({
  auth: authReducer,
  getUserList: getUserListReducer,
  getUserDetails: getUserDetailsReducer,
  getAdvList: getAdvListReducer,
  getBrandingData: getBrandingListReducer,
  getAdvDetailsData: getAdvDetailsDataReducer,
  getPodcastList: getPodcastListReducer,
  getPodcastDetailsData: getPodcastDetailsDataReducer,
  getProfileData: getProfileReducer,
  getCmsData: getCmsDataReducer,
  getUserActivity: getUserActivityReducer,
  getAllocatedCategory: getAllocatedCategoryReducer,
  dashboardData: dashboardDataReducer,
  getUserActivityLog: getUserActivityLogReducer,
  cmsManagement: cmsManagementReducer,
  notification: notificationReducer,
 tenant: TenantnReducer,
});
